import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Vue logo",
  src: _imports_0
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HelloWorld = _resolveComponent("HelloWorld")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_HelloWorld, { msg: "Add Person view!" })
  ]))
}